export class RegexConstants {
    static readonly FILENAME_PATTERN = '^[A-Z_0-9_a-z -]*$';
    static readonly STARTING_SPACE_VALIDATIOR_PATTERN = '^[A-Z_0-9_a-z ]*$';
}
